// data/regionSettings.js
export const DEFAULT_REGION_SETTINGS = {
  tileWidth: 1.5,
  tileHeight: 1.5,
  groutWidth: 0.001,
  groutColor: "#11141c",
  layout: "default",
};
